import React__default from "react";
import clsx from "clsx";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { Button } from "../../button/button.mjs";
const CarouselNavButton = (props) => {
  const { className, arrowType, link, size: sizeProp, ...rest } = props;
  const size = sizeProp || link === true ? sizeProp : "small";
  return /* @__PURE__ */ React__default.createElement(
    AnalyticsTrigger,
    {
      trigger: {
        callback: "onClick",
        id: "Link - Carousel - ".concat(arrowType === "next" ? "Next" : "Previous"),
        elementType: "carousel-navigation",
        elementId: arrowType === "next" ? "Next" : "Previous"
      }
    },
    /* @__PURE__ */ React__default.createElement(
      Button,
      {
        ...rest,
        size,
        link,
        icon: arrowType === "next" ? "#arrow-right" : "#arrow-left",
        className: clsx("carousel__nav", "carousel__nav--".concat(arrowType), className),
        tabIndex: -1
      }
    )
  );
};
export {
  CarouselNavButton
};
